import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiGet, apiPost, apiDelete } from './client';

export interface WhitelistEntry {
  id: string;
  email: string;
  addedBy: string;
  createdAt: string;
}

export function useGoogleWhitelist() {
  const qc = useQueryClient();

  const list = useQuery<WhitelistEntry[]>({
    queryKey: ['google-whitelist'],
    queryFn: () => apiGet<WhitelistEntry[]>('/admin/google-whitelist'),
  });

  const add = useMutation({
    mutationFn: (email: string) => apiPost('/admin/google-whitelist', { email }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['google-whitelist'] }),
    onError: (e: Error) => toast.error(e.message),
  });

  const remove = useMutation({
    mutationFn: (email: string) =>
      apiDelete('/admin/google-whitelist?email=' + encodeURIComponent(email)),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['google-whitelist'] }),
    onError: (e: Error) => toast.error(e.message),
  });

  return { list, add, remove };
}
